// extracted by mini-css-extract-plugin
export default {"shell":"PageShell_shell__yD92i"};